module.exports = __webpack_public_path__ + "static/img/butterflies.ce22038.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/butterflies.png
// module id = nPHu
// module chunks = 0